/**
 * Returns the corresponding page type string based on the provided Sitecore template ID.
 *
 * This is useful for identifying logical page types such as "provider", "teaching-sheet", etc.
 * It supports case-insensitive matching and provides a default fallback.
 *
 * @param templateId - The Sitecore template ID for the current page.
 * @returns A string representing the logical page type (e.g., 'provider', 'find-care', 'general').
 */
export function getPageTypeByTemplateId(templateId: string): string {
  const typeMap: Record<string, string> = {
    '74D0E5B8-4EE3-43F0-9E9E-F9A755D6A420': 'find-care', // Find care page
    // '2B0DC9BB-9E4D-4B3F-AB08-5F14369A4CAF': 'teaching-sheet', Teaching sheet page
    'D2B65608-E58C-4E89-9A58-25FD1474C762': 'general', // General page T2
    '6DE30456-2D7D-4D28-BF1B-2B2B8AA42E62': 'provider', // Provider Page
    '1FC43940-E22A-4F0A-8453-1DB23934AA03': 'specialty-header', // Specialty Header
    '1F627E91-79F2-4CE5-A18A-BF33972B2072': 'blog-details', // Blog details
    '5E737118-A376-4922-84C8-D2D641302D2D': 'location', // Location page
    '7C896918-DA7A-462A-B019-C2EFEE5CA462': 'hospital', // Hospital Location page
    '38ED8A97-A75B-4FB8-9542-7C8D0580C99A': 'mentalhealth', // Mental Health Location page
    '9BD22512-951A-451A-86B6-44203D1E4801': 'primarycare', // Primary Care Location page
    '4146A279-E77B-4E44-ADC6-57C059D4E80E': 'specialtycare', // Specialty Care Location page
    '569B9852-17F9-41A4-B6EC-AC740488C05B': 'urgentcare', // Urgent Care Location page
    '503BAF9C-C27E-4BC4-9E42-31D3643E4B41': 'teaching-sheet', // Teaching sheet page
  };

  return typeMap[templateId.toUpperCase()] || 'unknown';
}
